<template lang='pug'>
  .row(style="margin-top: 50px;")
    .col-12.col-md-3.d-md-block(v-if="advanced_search", :class="{'d-none': !filterOpen}")
      .card.border-primary
        .card-header.bg-primary
          .d-md-none.float-right(type="button" @click="filterOpen=false" v-if="filterOpen")
            svg(style="width:24px;height:24px", viewBox="0 0 24 24")
              path(fill="#fff", d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z")
          h4.mb-0.text-white Produkt Filter
        .card-body
          h5.mt-1 Kategories
          v-select(
            v-model="query.categories"
            :options="infos.categories"
            :multiple="true"
            placeholder="Bitte auswählen"
            @option:selected="advancedSearch"
            @option:deselected="advancedSearch"
          )
          h5.mt-4 Enthaltene Zutaten
          v-select(
            v-model="query.include_ingredients"
            :options="infos.ingredients"
            :multiple="true"
            placeholder="Bitte auswählen"
            @option:selected="advancedSearch"
            @option:deselected="advancedSearch"
          )
          h5.mt-4 Ausgeschlossene Zutaten
          v-select(
            v-model="query.exclude_ingredients"
            :options="infos.ingredients"
            :multiple="true"
            placeholder="Bitte auswählen"
            @option:selected="advancedSearch"
            @option:deselected="advancedSearch"
          )
          h5.mt-4 Frei von
          v-select(
            v-model="query.free_froms"
            :options="infos.free_froms"
            :multiple="true"
            placeholder="Bitte auswählen"
            @option:selected="advancedSearch"
            @option:deselected="advancedSearch"
          )
          h5.mt-4 Vegan
          v-select(
            v-model="query.vegan"
            :options="vegan"
            :multiple="false"
            placeholder="Bitte auswählen"
            @option:selected="advancedSearch"
            @option:deselected="advancedSearch"
          )
        .m-2(v-for="(name, value) in nutritions")
          h5.mt-3(v-if="name == 'price'") {{name}}
          h5.mt-3(v-else) {{name}} pro 100g
          .m-3(v-if="defaultQuery[value]")
            slider(
              :value="defaultQuery[value]"
              :min="0"
              :max="defaultQuery[value][1]"
              :tooltips="false"
              @input="(x) => {updateRange(x, value); advancedSearch()}"
              :step="0.2"
            )
            div
              .float-start {{toNumber(query[value][0])}} {{units[value] || "g"}}
              .float-end {{toNumber(query[value][1])}} {{units[value] || "g"}}
        .m-2.mt-4.text-end: a.btn.btn-sm.btn-outline-primary(href="/eat-search?advanced_search=1") Fitler zurücksetzten
    .col
      form(@submit="fetch")
        .input-group.search-top-bar
          input.form-control(
            type="text"
            name="code"
            placeholder="Suche ..."
            aria-label="Suche"
            v-model="q"
            :class="{noneborder: advanced_search}"
          )
          v-select(
            v-if="advanced_search"
            v-model="order"
            :options="orderOptions"
            placeholder="Bitte auswählen"
            @input="advancedSearch"
            :clearable="false"
          )
          button.btn.btn-primary(type="submit")
            svg(style="width:24px;height:24px", viewBox="0 0 24 24")
              path(fill="#fff", d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z")
        button.btn.btn-outline-primary.btn-block.mt-3.d-md-none(type="button" @click="filterOpen=true" v-if="!filterOpen && advanced_search")
          svg(style="width:20px;height:20px;margin-right:5px", viewBox="0 0 24 24")
            path(fill="currentColor", d="M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z")
          | Filter anzeigen
      div(v-if="loading && (cachedQ && cachedQ.length != 0 || advanced_search)")
        .d-flex.justify-content-center.mt-5: .spinner-border.text-primary(style="width: 3rem; height: 3rem;")
      div(v-else-if="results.length === 0 && (cachedQ && cachedQ.length != 0 || advanced_search)")
        .alert.alert-info.alert-has-icon(role="alert" style="margin-top: 25px;")
          svg(style="width:24px;height:24px;float: left; margin-right: 10px;", viewBox="0 0 24 24")
            path(fill="currentColor", d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z")
          .alert-content-container
            .alert-content
              | Es wurden keine mit deiner Suchanfrage 
              strong(v-if="cachedQ && cachedQ.length != 0") „{{cachedQ}}“  
              |  übereinstimmenden Dokumente gefunden.
      div(v-for="r in results" style="width: 100%; margin-top: 50px;" :key="r.title")
        a(:href="link(r.path)" @click="(e) => openLink('image', r.path, e)"): div(:style='styleForImage(r)')
        div(style="width: 100%")
          div()
            span(v-for="b in r.breadcrumbs")
              a(:href="link(r.path)" @click="(e) => openLink('breadcrumb', b.path, e)") {{b.title}}
              svg(style="width:15px;height:15px;margin:3px;margin-top:0px;", viewBox="0 0 24 24")
                path(fill="#878787", d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z")
          h2: a(:href="link(r.path)" @click="(e) => openLink('headline', r.path, e)") {{r.title}}
          p.d-none.d-lg-inline(v-html="r.teaser" style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3;")
          p.d-lg-none(v-html="r.teaser_mobil" style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3;")
</template>

<script>
import vSelect from 'vue-select'
import Slider from '@vueform/slider'
export default {
  name: 'App',
  props: ['costumer'],
  components: {vSelect, Slider},
  data() {
    return {
      advanced_search: false,
      value: [0, 50],
      infos: {},
      orders: [
        {id: "created_at:desc", label: "Neuheit absteigend"},
        {id: "created_at:asc", label: "Neuheit aussteigend"},
        {id: "order_score:desc", label: "Beliebt absteigend"},
        {id: "name:desc", label: "Alphabetisch absteigend"},
        {id: "name:asc", label: "Alphabetisch aussteigend"},
      ],
      order: {id: "created_at:desc", label: "Neuheit absteigend"},
      vegan: [
        {id: "t", label: "Vegan"},
        {id: "f", label: "nicht Vegan"},
      ], 
      filterOpen: false,
      units: {
        price: "€",
        kcal: "kcal"
      },
      nutritions: {
        price: "Preis",
        carbohydrates: "Kohlenhydrate",
        fat: "Fett",
        fat_full: "gesättigte Fettsäuren",
        kcal: "Brennwert",
        protein: "Protein (Eiweiß)",
        salt: "Salz",
        sugar: "Zucker"
      },
      query: {},
      queryParams: {},
      defaultQuery: {},
      q: "",
      cachedQ: "",
      loading: false,
      results: [],
      endPoint: "https://api.eat-performance.com"
      // endPoint: "http://localhost:3000"
    }
  },
  mounted(){
    const searchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(searchParams.entries());

    if (params.advanced_search == "1"){
      this.advanced_search = true
    }
    this.queryParams = params;
    this.query = {
      vegan: this.vegan.find(x => x.id == params.vegan)
    };
    this.getInfos()
    if (params.q && !this.advanced_search){
      this.q = params.q
      this.fetch()
    }
  },
  computed: {
    orderOptions(){
      let options = this.orders
      for (const [key, value] of Object.entries(this.nutritions)) {
        options.push({id: key+":desc", label: value+" absteigend"})
        options.push({id: key+":asc", label: value+" aufsteigend"})
      } 
      return options     
    },
    params(){
      let params = {}
      for (const [key] of Object.entries(this.nutritions)) {
        params[key+"_min"] = (this.query[key]||{})[0]-0.01
        params[key+"_max"] = (this.query[key]||{})[1]
      }
      params.exclude_ingredients = this.query.exclude_ingredients
      params.include_ingredients = this.query.include_ingredients
      params.free_froms = (this.query.free_froms||[]).map(x => x.id)
      params.categories = (this.query.categories||[]).map(x => x.id)
      params.vegan = (this.query.vegan||{}).id
      params.order = (this.query.order||this.order).id
      return params
    }
  },
  methods: {
    advancedSearch(){
      this.loading = true
      let params = {
        query: JSON.stringify(this.params),
        q: this.q,
        token: localStorage.searchtoken,
        customer_id: this.costumer
      }

      const queryString = [];
      for (const key in params) {
        queryString.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      }

      fetch(`${this.endPoint}/search/products.json?${queryString.join('&')}`, this.params).then(response => response.json()).then(data => {
        this.loading = false
        localStorage.searchtoken = data.token
        this.results = data.results.products

        if (this.q && this.q.length != 0){
          document.querySelectorAll('#extern_script').forEach(e => e.remove());
          const script = document.createElement("script");
          script.src = 'https://t.adcell.com/js/inlineretarget.js?method=search&pid=12481&search='+this.q+'&productIds='+this.results.map(x => x.product_id).filter(x => x)+'&productSeparator=,';
          script.id = "extern_script";
          document.body.appendChild(script);
        }

      });
    },
    toNumber(number){
      return Intl.NumberFormat('de-DE', { minimumSignificantDigits: 3, maximumSignificantDigits: 3 }).format(number)
    },
    updateRange(x, value){
      let query = this.query
      query[value] = x
      this.query = {}
      this.query = query
    },
    getInfos(){
      fetch(`${this.endPoint}/search/infos.json`).then(response => response.json()).then(data => {
        this.infos = data
        for (const [key, value] of Object.entries(data.max_values)) {
          this.defaultQuery[key] = [this.queryParams[key+"_min"]||0, value+0.01]
          this.query[key] = [this.queryParams[key+"_min"]||0, value+0.01]
        }
        if (this.queryParams.free_from){
          this.query.free_froms = data.free_froms.filter(x => x.id == this.queryParams.free_from)
        }
        if (this.advanced_search) this.advancedSearch()
      })
    },
    openLink(action, path, e){
      e.preventDefault();
      fetch(`${this.endPoint}/track.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          click_action: action,
          path: path,
          token: localStorage.searchtoken
        })
      }).then(() => window.location.href = this.link(path) )
    },
    link(path){
      if (path && path.startsWith("/")){
        return `https://eat-performance.com${path}`
      }else{
        return `https://eat-performance.com/${path}`
      }      
    },
    styleForImage(r){
      let image_url = encodeURI(r.image_url || 'https://eat-performance.com/media/29/50/80/1612789544/eat-logo.png')
      return `min-width: 60px; min-height: 60px; margin-right: 15px; position: relative; padding-top: 10%; width: 10%; float: left; background-image: url(${image_url}); background-size: cover; background-position: center; background-color: #fff; border: 1px solid #ddd; border-radius: 5px; cursor: pointer;`
    },
    fetch(e){
      if(e) e.preventDefault();

      if (this.advanced_search){
        this.advancedSearch()
        return
      }

      if (!this.q || this.q.replaceAll(" ", "").length === 0) return 
      
      this.loading = true
      this.cachedQ = this.q

      let inputs = document.querySelectorAll('.header-search-input')
      for (let n = 0; n < inputs.length; ++n) {
        inputs[n].value = this.q
      }
      
      fetch(`${this.endPoint}/search.json?q=${this.q}&token=${localStorage.searchtoken}&customer_id=${this.costumer}`).then(response => response.json()).then(data => {
        this.loading = false
        localStorage.searchtoken = data.token
        this.results = Object.values(data.results).flat().sort((a, b) => a.search_score > b.search_score ? -1 : 1);

        if (this.q && this.q.length != 0){
          document.querySelectorAll('#extern_script').forEach(e => e.remove());
          const script = document.createElement("script");
          script.src = 'https://t.adcell.com/js/inlineretarget.js?method=search&pid=12481&search='+this.q+'&productIds='+this.results.map(x => x.product_id).filter(x => x)+'&productSeparator=,';
          script.id = "extern_script";
          document.body.appendChild(script);
        }
      });
    }
  }  
}
</script>

